"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Sep 26 2018
 */

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>
 *     Data transfer object describing row within data pairing overview (overview of recommended and unpaired products).
 * </p>
 *
 * @author RV
 */


var DataPairingStatsDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DataPairingStatsDTO, _DomainObject_1$Domai);

  /**
   * @param categoryId internal id of category
   * @param numberOfRecommended number of recommended per category
   * @param numberOfUnpaired number of internal products per category
   */
  function DataPairingStatsDTO(categoryId, numberOfRecommended, numberOfUnpaired) {
    var _this;

    _classCallCheck(this, DataPairingStatsDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPairingStatsDTO).call(this));
    _this.categoryId = categoryId;
    _this.numberOfRecommended = numberOfRecommended;
    _this.numberOfUnpaired = numberOfUnpaired;
    return _this;
  }

  return DataPairingStatsDTO;
}(DomainObject_1.DomainObject);

exports.DataPairingStatsDTO = DataPairingStatsDTO; // tslint:disable-next-line:member-ordering

DataPairingStatsDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DataPairingStatsDTO.name);
  return {
    categoryId: builder.str('categoryId'),
    numberOfRecommended: builder.num('numberOfRecommended'),
    numberOfUnpaired: builder.num('numberOfUnpaired')
  };
}();